import { ArrowUpDown } from 'lucide-react';

import { useTranslation } from 'react-i18next';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';

export type SortOption = {
	/** API `sort` param, e.g. "createdAt:desc". Must use the endpoint's allowlisted fields. */
	value: string;
	/** Already translated. */
	label: string;
};

export type SortSelectProps = {
	options: readonly SortOption[];
	value: string;
	onChange: (value: string) => void;
	className?: string;
};

/** Sort dropdown for card and grid lists, which have no column headers to click. */
export function SortSelect({ options, value, onChange, className }: SortSelectProps) {
	const { t } = useTranslation();
	return (
		<Select value={value} onValueChange={onChange}>
			<SelectTrigger
				aria-label={t('common.sort.by')}
				className={cn('bg-input w-44 lg:w-52 h-8 lg:min-h-10 text-xs lg:text-sm', className)}
			>
				<ArrowUpDown className="size-3.5 opacity-60" />
				<SelectValue />
			</SelectTrigger>
			<SelectContent position="popper">
				{options.map((option) => (
					<SelectItem key={option.value} value={option.value}>
						{option.label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}
